<template>
    <div class="background">
        <myHead
            isTransparent
        />
        <div class="account-box">
            <div class="account-img-item">
                <van-image class="img-class" fit="cover" radius="50%" :src="userinfo.profile"/>
            </div>
            <div class="account-text-item">
                <div class="account-title">
                    {{userinfo.username}}
                </div>
                <div class="account-des">每天进步一点点</div>
            </div>
            <!-- 签到 -->
            <div class="sign-in-wrap">
                <van-button round type="primary" @click="doSignIn"
                            size="small" :disabled="signed">
                    &nbsp;签到&nbsp;
                </van-button>
            </div>
        </div>
        <!---->
        <div class="list-box">
            <div class="guide-box">
                <div class="guide-item" v-for="(item, index) in guideData" :key="index">
                    <router-link :to="item.path">
                        <div class="guide-item-img"><img class="img-shell" :src="item.cover" alt=""/></div>
                        <div class="guide-item-title"><span>{{item.title}}</span></div>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- 个人信息,我的积分,我的收藏 -->
        <div class="list-box">
            <div class="content-box">

                <van-cell-group>
                    <van-cell size="large" :title-style="cellTitleSty" title="积分兑换" @click="toPointStore">
                        <template #icon>
                            <van-icon class="collapse-img" name="coupon" />
                        </template>
                    </van-cell>

                    <van-cell size="large"
                              :title-style="cellTitleSty"
                              title="我的兑换" @click="toMyPrecious">
                        <template #icon>
                            <van-icon class="collapse-img" name="point-gift" />
                        </template>
                    </van-cell>

                    <van-cell size="large" is-link to="/my/setting"
                              :title-style="cellTitleSty"
                              title="设置">
                        <template #icon>
                            <van-icon class="collapse-img" name="setting" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>
        </div>
    </div>
</template>


<script>
import head from "../../components/myHeader";
import {getUserinfo, signIn} from "@/api/CommonApi";
import {Toast} from "vant";

const info_icon = require('../../../public/resource/my/information_icon.png')
const integral_icon = require('../../../public/resource/my/integral_icon.png')
const collection_icon = require('../../../public/resource/my/collection_icon.png')

export default{
    name:'my',
    components:{
        myHead:head,
    },
    data(){
        return{
            guideData:[
                {title:'个人信息', cover: info_icon, path:'/my/info'},
                {title:'我的积分', cover: integral_icon, path:'/my/point/history'},
                {title:'我的收藏', cover: collection_icon, path:'/my/collect',}
            ],
            // accountData:{cover:require('../../../public/resource/my/ig.png'), title:'果果西', description:'每天进步一点点',path:''},
            // 当前登录用户信息
            userinfo:{
                id:null,
                username:"--",
                phone:null,
                createTime:null,
                profile:null,
                gender:null
            },
            activeName:[],
            cellTitleSty:{
                lineHeight:'30px',
                marginLeft:'10px',
            },
            signed:false,
        }
    },
    setup(){

    },
    created() {
        const token = localStorage.getItem('token')
        if(!token){
            this.$router.replace('/login')
            return;
        }
        // check is sign
        let date = localStorage.getItem('signed')
        date = new Date(date).setHours(0,0,0,0);
        const now = new Date().setHours(0,0,0,0);
        this.signed = date === now
        // 加载用户信息
        this.loadAccountData()
    },
    methods:{
        // 加载帐户数据
        loadAccountData(){
            getUserinfo().then(res => {
                this.userinfo = res.result
            }).catch(() => {
                // 登录状态失效,跳转到登录页
                return this.$router.replace('/login')
            })
        },
        // 签到
        doSignIn() {
            if(this.signed){
                return
            }
            signIn().then(() => {
                Toast.success('签到成功')
                this.signed = true
                localStorage.setItem('signed',`${new Date()}`)
            })
        },
        // 转跳至积分兑换
        toPointStore() {
            this.$router.push('/my/point/store')
        },
        // 转跳至我的兑换
        toMyPrecious() {
            this.$router.push('/my/precious')
        }
    }
}
</script>

<style scoped>
.background{
    width:100vw;
    min-height: 100vh;
    background-repeat: no-repeat;
    background-image: url('../../../public/resource/my/head.png');
    background-position: center top;
    background-size: 100vw 55vw;
    background-color: RGBA(246, 246, 246, 1);
}

.account-box{
    width:100vw;
    height:110px;
    display:flex;
    justify-content: flex-start;
    align-items: center;

}


.account-img-item{
    width:25vw;
    height:80px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right:5vw

}
.img-class{
    width:60px;
    height:60px;
    border-radius:30px;
    display:inline-block;
    box-shadow: 0 0 2px grey;
    object-fit: cover;
 }
.account-text-item{
    width:40vw;
    height:80px;
    padding:10px;

}

.account-title{
    width:40vw;
    height:40px;
    font-size:24px;
    line-height:50px;
    color:white;

}

.account-des{
    width:40vw;
    height:20px;
    font-size:15px;
    line-height:25px;
    color:white;
}

.list-box{
    width:100vw;
    min-height:30vw;
    display:flex;
    justify-content: center;
    align-items: center;
}

.guide-box{
    width:95vw;
    height:30vw;
    border-radius: 10px;
    background-color:white;
    display:flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 0 1px darkgrey;
}

.guide-item{
    width:70px;
    height:70px;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

}

.guide-item-img{
    width:70px;
    height:40px;
    line-height: 75px;
    text-align: center;
}
.img-shell{
    width:40px;
    height:40px;
    object-fit: fill;
}
.guide-item-title{
    width:70px;
    height:30px;
    color:black;
    font-size:16px;
    display:flex;
    justify-content: center;
    align-items: flex-end;
}
.content-box{
    width:95vw;
    min-height:30vw;
    background-color: #FFFFFF;
    border-radius:10px;
    margin:30px 0;
    box-shadow: 0 0 1px darkgrey;
    padding:10px;
    box-sizing: border-box;
    z-index:5;
}
.collapse-img{
    width:30px;
    height:30px;
    object-fit: fill;
    vertical-align: middle;
    font-size: 22px;
    text-align: center;
    line-height: 30px;
    color: #1195db;
}
</style>
